"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Colors = _interopRequireDefault(require("./Colors"));

var RadioButton = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(RadioButton, _React$Component);

  function RadioButton() {
    (0, _classCallCheck2.default)(this, RadioButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RadioButton).apply(this, arguments));
  }

  (0, _createClass2.default)(RadioButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          style = _this$props.style,
          value = _this$props.value;
      var _this$context$radioBu = this.context.radioButtonGroup,
          name = _this$context$radioBu.name,
          _onChange = _this$context$radioBu.onChange,
          selectedValue = _this$context$radioBu.selectedValue;
      var isChecked = value === selectedValue;
      return _react.default.createElement("label", {
        className: (0, _classnames.default)((0, _defineProperty2.default)({
          'radio-button cursor-pointer block no-select margin-bottom-1': true,
          'bold': isChecked
        }, className, className)),
        style: style
      }, _react.default.createElement("div", {
        className: "flex-row"
      }, _react.default.createElement("input", {
        className: "hidden",
        checked: isChecked,
        name: name,
        onChange: function onChange() {
          return _onChange(value);
        },
        type: "radio",
        style: {
          height: 0,
          width: 0
        }
      }), _react.default.createElement("div", {
        className: "circle margin-right-1 relative",
        style: {
          borderColor: isChecked ? _Colors.default['grey-d'] : _Colors.default['grey-l'],
          borderStyle: 'solid',
          borderWidth: 1,
          height: 16,
          top: -1,
          width: 16
        }
      }, _react.default.createElement("div", {
        className: "circle absolute",
        style: {
          height: 12,
          left: 2,
          top: 2,
          width: 12,
          background: isChecked ? _Colors.default['blue'] : 'white'
        }
      })), _react.default.createElement("div", {
        className: "flex-1"
      }, children)));
    }
  }]);
  return RadioButton;
}(_react.default.Component);

;
RadioButton.contextTypes = {
  radioButtonGroup: _propTypes.default.object
};
var _default = RadioButton;
exports.default = _default;